import { render } from "./vrecpositionaddspecial.vue?vue&type=template&id=7088b054&scoped=true"
import script from "./vrecpositionaddspecial.vue?vue&type=script&lang=js"
export * from "./vrecpositionaddspecial.vue?vue&type=script&lang=js"

import "./vrecpositionaddspecial.vue?vue&type=style&index=0&id=7088b054&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7088b054"]])

export default __exports__